'use client';

import Modal from '../modal'

// Style
import Style from "./global-loader.module.scss"

// Global context
import useGlobalCtx from '@src/context/global-ctx';

function GlobalLoader({ className = "" }) {
  const { showLoader } = useGlobalCtx();
  
  return (
    <Modal
      isOpen={showLoader}
      className="z-50"
    >
      <div className={`${Style['loader']} ${className}`}></div>
    </Modal>
  )
}

export default GlobalLoader